import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';

export const Wrapper = styled.div``;

export const LabelRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 8px;
`;

export const Label = styled.label`
	display: block;
	color: var(--color-white-05);
	font-size: 16px;
	line-height: 20px;
`;

export const TooltipPointer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 18px;
	height: 18px;
	border: 1px solid var(--color-white-05);
	border-radius: 50%;
	cursor: help;
`;

export const InfoButton = styled.button`
	${hoverable}

	display: flex;
	justify-content: center;
	align-items: center;
	width: 18px;
	height: 18px;
	color: var(--color-white-05);
	font-size: 14px;
	font-weight: 500;
	border: 1px solid var(--color-white-05);
	border-radius: 50%;
`;

export const TooltipBox = styled.div`
	width: 300px;
`;

export const Description = styled.div`
	margin-top: 4px;
`;

export const Error = styled.div`
	margin-top: 4px;
`;
